import { Route as DiariesRoute } from "@/routes/_app/diaries";

export const diariesBreadcrumb = {
	label: "Diaries",
	route: { to: DiariesRoute.to },
};

import { Route as EditDiaryRoute } from "@/routes/_app/diaries/$diaryId/edit";

export const editBreadcrumb = {
	label: "Edit",
	route: { to: EditDiaryRoute.to },
};
